function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { withGenericConfig } from "contexts/generic-config-context";
import { HEADER_LINK_CLICKED } from "/constants/bigbrain-event-types";
import { trackEvent } from "/services/bigbrain-service";
import { fireGtmEvent } from "client/services/gtm-service/gtm-service";
import DataLayerEventTypes from "constants/data-layer-event-types";
import { StyledLinkItemComponent } from "./link-item-component.scss";
class LinkItemComponent extends PureComponent {
    render() {
        const { title, url, translate } = this.props;
        const role = url ? "link" : "button";
        return /*#__PURE__*/ _jsx(StyledLinkItemComponent, {
            href: url,
            role: role,
            className: "link-item-component",
            onClick: this.onClick,
            tabIndex: "0",
            onKeyPress: this.onClick,
            children: translate(title)
        });
    }
    constructor(...args){
        super(...args);
        _define_property(this, "onClick", (e)=>{
            const { url, title, clickEvent, translate } = this.props;
            const isKeyboardEvent = (e === null || e === void 0 ? void 0 : e.screenX) === 0 && (e === null || e === void 0 ? void 0 : e.screenY) === 0;
            trackEvent(HEADER_LINK_CLICKED, {
                kind: url,
                info1: isKeyboardEvent ? "keyboard" : "mouse",
                info2: title
            });
            fireGtmEvent(DataLayerEventTypes.CLICK_MAIN_NAV, {
                click_text: translate(title)
            });
            if (clickEvent) clickEvent();
        });
    }
}
export default withGenericConfig(LinkItemComponent);
